import {
  Children,
  cloneElement,
  isValidElement,
  useEffect,
  useRef,
  useState,
} from "react";
import "./Expandable.css";

/**
 * @param {ReactNode} summary - The summary content displayed when the section is collapsed
 * @param {ReactNode} children - The content displayed when the section is expanded
 * @param {string} name - The name attribute for the <details> element. This attribute ensures only one element is opened at a time within a group of details elements sharing the same name.
 */
export const Expandable = ({
  summary,
  name,
  children: Children,
  id,
  isOpen,
  onToggle,
  isChildOpen,
}) => {
  const preventHide = useRef(false);

  const keyupHandler = (e) => {
    switch (e.code) {
      case "ArrowUp":
        e.currentTarget.previousElementSibling
          ?.querySelector(":scope>details")
          ?.querySelector("summary")
          ?.focus();
        break;
      case "ArrowDown":
        e.currentTarget.nextElementSibling
          ?.querySelector(":scope>details")
          ?.querySelector("summary")
          ?.focus();
        break;
      default:
    }
  };

  return (
    <div className={`expandable-component ${isChildOpen || isOpen? 'active-expandable' : ''}`} onKeyUp={keyupHandler} id={id}>
      {Boolean(summary) && (
        <details
          className={`${isOpen || isChildOpen ? "openSticky" : ""}`}
          name={name}
          open={isOpen}
          onToggle={(e) => {
            if (!preventHide.current) {
              onToggle(e.target.open);
            }
          }}
        >
          <summary>{summary}</summary>
        </details>
      )}
      <div
        className="expandable-details"
        style={!isOpen ? { visibility: "hidden" } : {}}
      >
        {isValidElement(Children)
          ? cloneElement(Children, { open: isOpen })
          : Children}
      </div>
    </div>
  );
};
